<template>
  <div @click="outsideClick()" class="modal">
    <div class="modal-box">
      <div @click="$emit('close')" class="close">
        <span>X</span>
      </div>
      <div class="modal-body" style="text-align: center;">
        <div class="form-box" style="padding: 1rem;">
          <h3>Muito obrigado por escolher a Health ID!</h3>
          <h4>Clique abaixo e registre seu kit.</h4>
          <h5>O número de registro do kit se encontra na embalagem metalizada dentro da caixa.</h5>
          <div class="img-box">
            <img src="@/assets/images/vector-fluxo-healthid-lab-com.png" width="300"/>
          </div>
          <div>
            <button class="button btn-orange" style="width: 100%;margin: 21px 0;" v-on:click.prevent="toRegisterKit">
              Registrar Kit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "register-kit-modal",
        methods: {
            toRegisterKit() {
                let url_string = window.location.href;
                let url = new URL(url_string);
                let kit = url.searchParams.get("kit_number");
                if(!!kit && kit != '') window.location = `/cadastrar-kit?kit_number=${kit}`;
                else this.$router.push('/cadastrar-kit');
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/ProfileSaveModal/RegisterKitModal.vue